import React, { memo } from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  tabValue: number;
  index: number;
  [key: string]: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, tabValue, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={tabValue !== index}
      id={`candidate-sourcing-tabpanel-${index}`}
      aria-labelledby={`candidate-sourcing-tab-${index}`}
      {...other}
    >
      {tabValue === index && <>{children}</>}
    </div>
  );
};

export default memo(TabPanel); 
